module.exports = __webpack_public_path__ + "static/media/selection-Dr_K_adamawe_K_nife.b90725c1.jpg";